import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, switchMap } from 'rxjs/operators';
import { ExchangeRatesService } from './exchangeRates.service';
import { of } from 'rxjs';
import * as fromActions from './slice';

@Injectable()
export class ExchangeRatesEffects {
  loadExchangeRates$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.loadExchangeRates),
      switchMap((_action) =>
        this.currencyService.loadExchangeRates().pipe(
          switchMap((exchangeRates) => of(fromActions.loadExchangeRatesSuccess({ exchangeRates }))),
          catchError(() => of(fromActions.loadExchangeRatesFailure()))
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly currencyService: ExchangeRatesService
  ) {}
}
